import React, { Component, PropTypes } from "react";
import Panel from "../../../../components/panel/Panel";
import cx from "classnames";
import * as qs from "query-string";
import { createHashHistory } from "history";
import { appConfig } from "../../../../config";
import { Button } from "react-bootstrap";
import { NewBreadcrumb as BreadcrumbComponent } from "../../../../components";

const history = createHashHistory();
class ViewSiteDetail extends Component {
  constructor(props) {
    const pathname = (props.location && props.location.pathname) && props.location.pathname
    var viewLink = pathname.substring(1);
    super(props);
    this.state = {
      path: ["Home", "Site List","View Site Details"],
      links: ["home","viewSiteList",viewLink]
    };
  }

  componentWillMount() {
    const id = location.hash.split("/");
    const {
      actions: { getSiteDetailsBySiteId }
    } = this.props;
    getSiteDetailsBySiteId(id[id.length - 1]);
  }

  render() {
    const headerTitle = "View Site Deatils";
    const sitedata = this.props.siteDataById ? this.props.siteDataById : [];

    return (
      <div className="col-lg-12">
        <BreadcrumbComponent path={this.state.path} links={this.state.links}/>
        <Panel hasTitle={true} title={headerTitle}>
          <div className="col-lg-9">
            <h3>Site Details</h3>
            <div className="task-content">
              <ul className="task-list">
                <li>
                  <b>Site Name:</b> {sitedata.siteName}
                </li>
                <li>
                  <b>Site Domain:</b> {sitedata.siteDomain}
                </li>
                {/*<li>
                  <b>Logo FileName:</b> {sitedata.siteLogo}
                </li>*/}
                <li>
                  <b>Site Status:</b> {sitedata.status}
                </li>
                <li>
                  <b>PayVibe Monthly Fee Amount: </b> $ {sitedata.monthlyFee}
                </li>
                <li>
                  <b>PayVibe Minimum Monthly Fee Amount: </b> $ {sitedata.minMonthlyFee}
                </li>
                <li>
                  <b>PayVibe Commission % Of Gross:</b> % {sitedata.commissionPercent}
                </li>
                <li>
                  <b>PayVibe Commission % of Net:</b> % {sitedata.payVibeCommissionNet}
                </li>
                <li>
                  <b>Invoice due date:</b> {sitedata.invoiceDueDate} days
                </li>
                <li>
                  <b>Contracts URL:</b> {sitedata.signed_nda_link}
                </li>
                <li>
                  <b>Site Key:</b> {sitedata.siteKey}
                </li>
              </ul>
            </div>
          </div>

          {/*<div className="col-lg-3">
            <img
              src={appConfig.site.siteurl + sitedata.siteLogo}
              width="100px"
            />
          </div>*/}

          <div className="col-lg-6">
            <h3>Site Admin Details</h3>
            <div className="task-content">
              <ul className="task-list">
                <li>
                  <b>User Name:</b> {sitedata.userName}
                </li>
                <li>
                  <b>Email:</b> {sitedata.email}{" "}
                </li>
                <li>
                  <b>First Name:</b> {sitedata.firstName}
                </li>
                <li>
                  <b>Last Name:</b> {sitedata.lastName}
                </li>
                <li>
                  <b>Date of Birth:</b> {sitedata.dob}{" "}
                </li>
                <li>
                  <b>Gender:</b> {sitedata.gender}
                </li>
                <li>
                  <b>Phone:</b> {sitedata.phone}
                </li>
                <li>
                  <b>Address1:</b> {sitedata.address1}
                </li>
                <li>
                  <b>Address2:</b> {sitedata.address2}
                </li>
                <li>
                  <b>Country:</b> {sitedata.userCountry}
                </li>
                <li>
                  <b>State:</b> {sitedata.userState}
                </li>
                <li>
                  <b>City:</b> {sitedata.city}
                </li>
                <li>
                  <b>City Id:</b> {sitedata.cityID}
                </li>
                <li>
                  <b>Zipcode:</b> {sitedata.zipcode}
                </li>
              </ul>
            </div>
          </div>
          <div className="col-lg-6">
            <h3>Company Address</h3>
            <div className="task-content">
              <ul className="task-list">
                <li>
                  <b>Country:</b> {sitedata.locCountryName}
                </li>
                <li>
                  <b>State:</b> {sitedata.locStateName}
                </li>
                <li>
                  <b>City:</b> {sitedata.locCity}
                </li>
                <li>
                  <b>City Id:</b> {sitedata.locCityID}{" "}
                </li>
                <li>
                  <b>Address1:</b> {sitedata.locAddress1}
                </li>
                <li>
                  <b>Address2:</b> {sitedata.locAddress2}
                </li>
                <li>
                  <b>Latitude:</b> {sitedata.locLatitude}
                </li>
                <li>
                  <b>Longitude:</b> {sitedata.locLongitude}
                </li>
                <li>
                  <b>Phone:</b> {sitedata.locPhone}
                </li>
              </ul>
            </div>
          </div>
          <div className="form-footer">
            <Button
              bsStyle="success"
              className="btn -default pull-right"
              onClick={() => history.push(`/viewSiteList`)}
            >
              Back
            </Button>
          </div>
        </Panel>
      </div>
    );
  }
}

export default ViewSiteDetail;



// WEBPACK FOOTER //
// ./src/app/views/manageSite/viewSiteList/viewSiteDetail/ViewSiteDetail.js